import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function ThemedSkeleton(props) {
  return (
    <SkeletonTheme baseColor="var(--gray-200)" highlightColor="var(--gray-50)">
      <Skeleton {...props} />
    </SkeletonTheme>
  );
}

export default ThemedSkeleton;
